import React, { useEffect, useState } from "react";
import ToastNotification from '../../../components/ToastNotification';
import { FaRegEye } from "react-icons/fa";
import { MdOutlineVerifiedUser } from "react-icons/md";
import Select, { components } from 'react-select';
import { CiViewList } from "react-icons/ci";
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import { CiEdit } from "react-icons/ci";
import axios from "axios";


function CostCenterLink({ adminData, branchID }) {


  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });

  const showToast = (message, bg = 'success') => {
    setToast({ show: true, message, bg });
  };


  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [user, setUser] = useState([]);
  const [linkedToOptions, setLinkedToOptions] = useState([]);
  const [linkedTo, setLinkedTo] = useState(null);
  const [linkType, setLinkType] = useState(null);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [options, setOptions] = useState([]);
  const [fetchCost, setFetchCost] = useState([]);


  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [costCenterName, setCostCenterName] = useState("");


  const handleAddClick = () => {
    setShowForm(true);
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!costCenterName || !selectedCategory) {
    showToast("Please fill all required fields", "warning");
    return;
  }

  const payload = {
    name: costCenterName,
    category_name: selectedCategory.label
  };

  try {
    if (editId) {
  
      await axios.put(
        `https://api.skyguard.group/api/update-cost-category/${editId}`,
        {
          ...payload,
          edited_by: adminData.user.id
        }
      );

      showToast("Cost center updated successfully", "success");
    } else {
    
      await axios.post(
        "https://api.skyguard.group/api/add-cost-category",
        {
          ...payload,
          added_by: adminData.user.id
        }
      );

      showToast("Cost center added successfully", "success");
    }

  
  resetForm();  
    fetchCostCenter();

  } catch (error) {
    console.error(error);
    showToast("Something went wrong", "danger");
  }
};

  const resetForm = () => {
setCostCenterName("");
    setSelectedCategory([]);
    setEditId(null);
    setIsEditMode(false);
    setShowForm(false);
  }

const handleAddCategory = () => {
  if (!categoryName.trim()) {
    showToast("Category name is required", "warning");
    return;
  }

  // prevent duplicates
  const exists = categoryOptions.some(
    cat => cat.label.toLowerCase() === categoryName.toLowerCase()
  );

  if (exists) {
    showToast("Category already exists", "warning");
    return;
  }

  const newCategory = {
    value: categoryName,
    label: categoryName
  };

  setCategoryOptions(prev => [...prev, newCategory]);
  setSelectedCategory(newCategory);

  setCategoryName("");
  setShowCategoryModal(false);

  showToast("Category added successfully", "success");
};



  

const fetchCostCenter = async () => {
  try {
    const res = await axios.get(
      "https://api.skyguard.group/api/fetch-cost-category"
    );

    const data = res.data; // array of cost centers
    setFetchCost(data);

    // 🔥 Extract UNIQUE categories
    const uniqueCategories = [
      ...new Set(data.map(item => item.category_name))
    ];

    const categoryDropdown = uniqueCategories.map(cat => ({
      value: cat,
      label: cat
    }));

    setCategoryOptions(categoryDropdown);

  } catch (error) {
    console.log(error);
  }
};


  useEffect(() => {
    fetchCostCenter();
  }, [])







const handleEdit = (row) => {
  setEditId(row.id);
  setIsEditMode(true);
  setShowForm(true);

  setCostCenterName(row.name);

  setSelectedCategory({
    value: row.category_name,
    label: row.category_name
  });
};


const filteredData = Array.isArray(fetchCost)
  ? fetchCost.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
  : [];


  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };


  const getFullName = (first, middle, last) => {
    return [first, middle, last].filter(Boolean).join(" ");
  };

  return (
    <>

      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <h3 className='my-3 fw-bold fs-5 golos'>Cost Center Link</h3>

          <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">


            <div className="mb-2 w-50 w-md-50 pe-md-2">
              <input
                className="form-control w-100"
                list="datalistOptions"
                placeholder="Search ...."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>


            <div className="mb-2">
              <button className="btn btn-success" onClick={handleAddClick}>
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>

          </div>


          {showForm && (
            <div className="row justify-content-center">
              <div className="col-12 col-sm-10 col-md-6 col-lg-5">
                <div className="card shadow-sm p-4 border-0">

                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">

{isEditMode && (
  <div className="mb-3">
    <span className="badge bg-primary px-3 py-2">
      {costCenterName || "No Cost Center"}
    </span>
  </div>
)}

                        <div className="col-12 mb-3">
  <label className="form-label fw-medium">Cost Center Name</label>
  <input
    type="text"
    className="form-control"
    value={costCenterName}
    onChange={(e) => setCostCenterName(e.target.value)}
    placeholder="Enter cost center name"
  />
</div>

                        <div className="col-12 mb-3">
                          <label className="form-label fw-medium d-flex justify-content-between">
                            <span>Cost Category</span>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => setShowCategoryModal(true)}
                            >
                              + Add
                            </button>
                          </label>

                          <Select
                            placeholder="Select Category"
                            isClearable
                            options={categoryOptions}
                            value={selectedCategory}
                            onChange={setSelectedCategory}
                          />
                        </div>
                      </div>

                      <div className="d-flex justify-content-center gap-2 mt-3">
                        <button className="btn btn-success px-4" onClick={handleSubmit}>
                          {editId ? "Update" : "Save"}
                        </button>

                        <button
                          type="button"
                          className="btn btn-secondary px-4"
                          onClick={() => {
                            setShowForm(false);
                            setIsEditMode(false);
                            resetForm();
                          }}
                        
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          )}



          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>

              <thead className='table-info'>
                <tr>
                  <th scope="col">SN</th>
                    <th scope='col'>Action</th>
                  <th scope='col'>Cost Center Name</th>
                  <th scope='col'>Category</th>
                  <th scope='col'>Added By</th>
                  <th scope='col'>Added Date</th>
                  <th scope='col'>Edit By</th>
                  <th scope='col'>Edit Date</th>
                
                </tr>
              </thead>
              <tbody>
                {filteredData.map((acc, idx) => (
                  <tr key={idx}>

                    <td>{acc.id} </td>
                       <td>
                      <button className="btn btn-success" onClick={() => handleEdit(acc)}>
                        <CiEdit size={20} />
                      </button>
                    </td>

                    <td>
                     {acc.name}
                    </td>

                    <td>
                      {acc.category_name}
                    </td>
                    <td>{acc.added_by_first} {acc.added_by_middle}  {acc.added_by_last}   </td>

                    <td> {formatDateTime(acc.created_at)}  </td>
                    <td>  {acc.edited_by_first
                      ? getFullName(
                        acc.edited_by_first,
                        acc.edited_by_middle,
                        acc.edited_by_last
                      )
                      : "-"}</td>


                    <td>{formatDateTime(acc.updated_at)}  </td>
                 
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {showCategoryModal && (
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">

                  <div className="modal-header">
                    <h5 className="modal-title">Add Cost Category</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowCategoryModal(false)}
                    />
                  </div>

                  <div className="modal-body">
                    <label className="form-label">Category Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={categoryName}
                      onChange={(e) => setCategoryName(e.target.value)}
                      placeholder="Enter category name"
                    />
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowCategoryModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleAddCategory}
                    >
                      Save
                    </button>
                  </div>

                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </>
  )
}

export default CostCenterLink